module.exports = __webpack_public_path__ + "media/images/gray-down-chevron-0ab59babaff381b3d784eb04acb29540.svg";